import Invoice from '../../src/legacy/Invoice.tsx';
export default Invoice;
